// @flow

/**
 * Client side form inputs validation
 */
export default function inputsFormValidation(
  formFields: Array<ClientFormField>,
  formData,
  currentErrors,
  emailConfirm
) {
  //alert("oo")
  // console.log("formFields", formFields);
  // console.log("formData", formData);
  // mandatory inputs validation
  let errors = currentErrors ? [...currentErrors] : [];
  // console.log("errors", errors);

  let formErrors = formFields
    .filter((formField) => formField.mandatory === true)
    .reduce((acc, curr) => {
      let formItem = formData.find(
        (inputData) =>
          inputData.clientFormInputType?.id ===
          curr._embedded.clientFormInputType.id,
      );
      if (!formItem || formItem.value === "") {
        // ajouter l’erreur si absente
        if (
          !errors.some(
            (err) =>
              err.id === curr._embedded.clientFormInputType.id &&
              err.type === "mandatory",
          )
        ) {
        if(curr._embedded.clientFormInputType.inputType === "ADDRESS"){
            errors.push({
            id: curr._embedded.clientFormInputType.id,
            type: "mandatory",
            fields: isValidAddress(),
          });
        } else{
          errors.push({
            id: curr._embedded.clientFormInputType.id,
            type: "mandatory",
          });
        }

        }
      } else {
          // supprimer l’erreur si présente
          errors = errors.filter(
            (err) =>
              !(
                err.id === curr._embedded.clientFormInputType.id &&
                err.type === "mandatory"
              ),
          );

          if(curr._embedded.clientFormInputType.inputType === "ADDRESS"){
                let errorAddress = isValidAddress(formItem.value);
                if(errorAddress.length > 0){
                    errors.push({
                    id: curr._embedded.clientFormInputType.id,
                    type: "mandatory",
                    fields: errorAddress,
                  });
                }
            }
        }

      return acc;
    }, []);

  // email validation
  let emailData = formData.filter(
    (inputData) => inputData.clientFormInputType?.code === "email",
  );

  let isEmailMandatory = formFields.some(
    (inputData) => 
      inputData._embedded.clientFormInputType.inputType === "EMAIL" && 
      inputData.mandatory === true
  );

  if (emailData.length > 0 ) {

    if (
        !isValidEmail(emailData[0].value) &&
        !(emailData[0].value.trim() === '' && !isEmailMandatory)
      ) {
      if (
        !errors.some(
          (err) =>
            err.id === emailData[0].clientFormInputType.id &&
            err.type === "invalid",
        )
      ) {
        errors.push({
          id: emailData[0].clientFormInputType.id,
          type: "invalid",
        });
      }
    } else {
      errors = errors.filter(
        (err) =>
          !(
            err.id === emailData[0].clientFormInputType.id &&
            err.type === "invalid"
          ),
      );
    }

  }

  if(emailConfirm == true || emailConfirm == undefined){
      let emailDataConfirm = formData.filter(
        (inputData) => inputData.clientFormInputType?.inputType === "EMAILCONFIRM",
      );
        //On test la validation du mail 
        if (emailDataConfirm.length > 0 && emailData.length > 0) {
          //reset de l erreur "confirmationrequired" si presente 
          if (
              errors.some(
                (err) =>
                  err.id === emailData[0].clientFormInputType.id &&
                  err.type === "confirmationrequired",
              )
            ) {
              // si présent retour de "errors" sans celle-ci
              errors = errors.filter(
                (err) =>
                  !(
                    err.id === emailData[0].clientFormInputType.id &&
                    err.type === "confirmationrequired"
                  ),
              );
            }


          if (
            !isValidEmail(emailDataConfirm[0].value) ||
            emailData[0].value != emailDataConfirm[0].value
          ) {
            if (
              !errors.some(
                (err) =>
                  err.id === emailData[0].clientFormInputType.id &&
                  err.type === "invalidconfirm",
              )
            ) {
              errors.push({
                id: emailData[0].clientFormInputType.id,
                type: "invalidconfirm",
              });
            }
          } else {
            errors = errors.filter(
              (err) =>
                !(
                  err.id === emailData[0].clientFormInputType.id &&
                  err.type === "invalidconfirm"
                ),
            );
          }
        } else {
          if (emailData.length > 0 && emailDataConfirm.length == 0) {
            if (
              !errors.some(
                (err) =>
                  err.id === emailData[0].clientFormInputType.id &&
                  err.type === "confirmationrequired",
              )
            ) {
              errors.push({
                id: emailData[0].clientFormInputType.id,
                type: "confirmationrequired",
              });
            } 
          }
  }
  }

  let isPhoneMandatory = formFields.some(
    (inputData) => 
      (inputData._embedded.clientFormInputType?.code === "mobilephone" || inputData._embedded.clientFormInputType?.code === "phone") && 
      inputData.mandatory === true
  );

  // phone number validation
  formData
    .filter(
      (formField) =>
        formField.clientFormInputType?.code === "mobilephone" ||
        formField.clientFormInputType?.code === "phone",
    )
    .map((phoneField) => {
      if (
        !phoneField.isValid &&
        !((phoneField.value?.trim() ?? '') === '' && !isPhoneMandatory)
      ) {
          if (
          !errors.some(
            (err) =>
              err.id === phoneField.clientFormInputType.id &&
              err.type === "invalid",
          )
        ) {
          errors.push({
            id: phoneField.clientFormInputType.id,
            type: "invalid",
          });
        }
      } else {
        errors = errors.filter(
          (err) =>
            !(
              err.id === phoneField.clientFormInputType.id &&
              err.type === "invalid"
            ),
        );
      }
    });

  return (errors);
}

const isValidAddress = (addressData) => {
    const addressParsed = addressData ? JSON.parse(addressData) : {};
    //console.log("addressParsed", addressParsed)
            let addressErrors = [];
            if (!addressParsed.street_number) {
              addressErrors.push("street_number");
            }
            if (!addressParsed.route) {
              addressErrors.push("route");
            }
            if (!addressParsed.postal_code) {
              addressErrors.push("postal_code");
            }
            if (!addressParsed.locality) {
              addressErrors.push("locality");
            }
            if (!addressParsed.code_pays) {
              addressErrors.push("country");
            }
          return addressErrors
}

const isValidEmail = (email) =>
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email,
  );

// function isValidEmail(email) {
//   const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
//   return re.test(email);
// }
